import React from 'react';
export const GuaranteeSection: React.FC = () => {
  return <section className="bg-[#F5F5EB] py-[70px] px-5 text-center" data-id="element-105" data-mp="1i59esgiyjvu2">
      <div className="max-w-[620px] mx-auto bg-white border-2 border-green-brand rounded-[20px] py-[50px] px-10 md:py-[35px] md:px-[22px]" data-id="element-106" data-mp="4w1hsx3wncky">
        <span className="text-[70px] block mb-5" data-id="element-107" data-mp="9wph062aezq9">🛡️</span>
        <h2 className="text-[clamp(22px,3.5vw,32px)] text-green-brand mb-[15px]" data-id="element-108" data-mp="eu8u32n916gm">
          Garantía 7 Días — Sin Preguntas
        </h2>
        <p className="text-[15px] text-[#555] font-sans leading-[1.8] mb-[15px]" data-id="element-109" data-mp="jqpt4rvzl58h">
          Abrís los 3 tomos. Aplicás la prueba del frasco con tu tierra. Usás la
          calculadora para tu terreno. Si en 7 días no es lo que esperabas:
        </p>
        <p className="text-[15px] text-[#555] font-sans leading-[1.8] mb-[15px]" data-id="element-110" data-mp="xivz5l5fdvu7">
          <strong data-id="element-111" data-mp="12jtezr2yqdsj">Devolución del 100% del dinero.</strong>
          <br data-id="element-112" data-mp="12gxk6bmew58b" />
          Sin formularios. Sin drama. Sin burocracia.
        </p>
        <div className="bg-[#F5F5EB] rounded-lg py-3 px-5 text-sm font-sans text-green-brand font-bold inline-block" data-id="element-113" data-mp="17id2vx149znj">
          Tasa de devoluciones: menos del 1% 🏆
        </div>
      </div>
    </section>;
};